export const homePageCarouselBannerCreativeName = 'Home page carousel banner';
